module.exports = __webpack_public_path__ + "img/publication.a73f5ad8.png";